import { mapObjIndexed } from 'ramda';
import { EngineType, } from '@zurich/common/types';
import { createUnits, removeUndefinedProps, } from '@zurich/common/utils';
export const formatUnits = (mappingObj, valueObj, context, t) => {
    const formattedObject = mapObjIndexed((value, key) => mappingObj[key]
        ? createUnits(value, mappingObj[key], context, t)
        : undefined, valueObj);
    return removeUndefinedProps(formattedObject);
};
const vehicleUnitMapping = {
    ['co2Emission']: 'co2',
    ['maxTotalWeightInTons']: 'kg',
    ['payloadInTons']: 'kg',
    ['performanceIceKw']: 'kW',
    ['performanceNonIceKw']: 'kW',
    ['performanceIcePs']: 'PS',
    ['performanceNonIcePs']: 'PS',
    ['initialRegistrationDate']: 'date',
    ['listPrice']: 'currency',
    ['telematik']: 'TriState',
    ['leasingVehicle']: 'TriState',
    ['manufacturer']: 'noUnit',
    ['model']: 'noUnit',
    ['engineType']: 'noUnit',
    ['noOfSeats']: 'noUnit',
    ['usageType']: 'noUnit',
    ['vehicleType']: 'noUnit',
};
const sortOfferVehicle = (offerVehicle) => ({
    vehicleType: offerVehicle.vehicleType,
    manufacturer: offerVehicle.manufacturer,
    model: offerVehicle.model,
    engineType: offerVehicle.engineType,
    performanceIceKw: offerVehicle.performanceIceKw,
    performanceKwTotal: offerVehicle.performanceKwTotal,
    performanceNonIceKw: offerVehicle.performanceNonIceKw,
    performanceIcePs: offerVehicle.performanceIcePs,
    performanceNonIcePs: offerVehicle.performanceNonIcePs,
    initialRegistrationDate: offerVehicle.initialRegistrationDate,
    co2Emission: offerVehicle.co2Emission,
    noOfSeats: offerVehicle.noOfSeats,
    usageType: offerVehicle.usageType,
    payloadInTons: offerVehicle.payloadInTons,
    maxTotalWeightInTons: offerVehicle.maxTotalWeightInTons,
    telematik: offerVehicle.telematik,
    leasingVehicle: offerVehicle.leasingVehicle,
    listPrice: offerVehicle.listPrice,
    additionalEquipmentSum: offerVehicle.additionalEquipmentSum,
    constructionYear: offerVehicle.constructionYear,
    firstRegistrationBeforeEcoTaxReform: offerVehicle.firstRegistrationBeforeEcoTaxReform,
    licensePlateType: offerVehicle.licensePlateType,
    boughtAtDealer: offerVehicle.boughtAtDealer,
    ccm: offerVehicle.ccm,
    condition: offerVehicle.condition,
    dangerousGoods: offerVehicle.dangerousGoods,
    garage: offerVehicle.garage,
    initialRegistrationYear: offerVehicle.initialRegistrationYear,
    mainDriver: offerVehicle.mainDriver,
    previousDamage: offerVehicle.previousDamage,
    registrationDistrict: offerVehicle.registrationDistrict,
    softTop: offerVehicle.softTop,
    usedOnRunway: offerVehicle.usedOnRunway,
    usedWithBluelight: offerVehicle.usedWithBluelight,
    additionalEquipments: offerVehicle.additionalEquipments,
    insuredObjectType: offerVehicle.insuredObjectType,
    insuredObjectId: offerVehicle.insuredObjectId,
    insuranceSegments: offerVehicle.insuranceSegments,
});
const filterForRender = (vehicle) => {
    const tmpVehicle = { ...vehicle };
    const fieldsToRemove = [];
    if (vehicle.vehicleType === 'LKW') {
        fieldsToRemove.push('telematik');
    }
    if (vehicle.vehicleType !== 'LKW') {
        fieldsToRemove.push('payloadInTons');
    }
    if (vehicle.engineType === EngineType.ELECTRO) {
        fieldsToRemove.push('performanceKwTotal');
        fieldsToRemove.push('performanceIceKw');
    }
    else {
        fieldsToRemove.push('performanceNonIceKw');
    }
    fieldsToRemove.push('performanceIcePs');
    fieldsToRemove.push('performanceNonIcePs');
    fieldsToRemove.forEach((value) => {
        delete tmpVehicle[value];
    });
    return tmpVehicle;
};
function setVehiclePropertyTranslation(key, value, t) {
    if (value === null) {
        return '';
    }
    switch (key) {
        case 'engineType':
        case 'usageType':
            return t(`contract:${key}.${value}`);
        default:
            return value;
    }
}
export const createVehicleSummaryRows = (offerDetails, context, t) => {
    const offerVehicle = filterForRender(sortOfferVehicle(offerDetails));
    const vehicle = Object.entries(formatUnits(vehicleUnitMapping, offerVehicle, context, t)).map(([key, value]) => ({
        label: t(`contract:vehicleLabels.${key}`),
        // because usageType and engineType has no unit mapping but need translations
        value: setVehiclePropertyTranslation(key, value, t),
    }));
    const additionalEquipmentRows = createAdditionalEquipmentSummary(offerVehicle?.additionalEquipments ?? [], context.formatMoneyAmount, t);
    if (additionalEquipmentRows.length > 1) {
        additionalEquipmentRows.push({
            label: t('contract:vehicleLabels.additionalEquipmentSum'),
            value: context.formatMoneyAmount(offerVehicle.additionalEquipmentSum) ?? null,
        });
    }
    return vehicle.concat(additionalEquipmentRows);
};
export const createAdditionalEquipmentSummary = (additionalEquipment, formatMoneyFunction, t) => additionalEquipment.reduce((prev, current) => {
    if (current.description && current.value) {
        return [
            ...prev,
            {
                label: current.description,
                value: formatMoneyFunction(Number.parseInt(current.value)),
            },
        ];
    }
    return prev;
}, [
    additionalEquipment.length > 0
        ? {
            label: t('contract:vehicleLabels.additionalEquipments'),
            value: `${t('contract:vehicleLabels.additionalEquipment.additionalEquipmentMoreThanFourThousand')}`,
        }
        : {
            label: t('contract:vehicleLabels.additionalEquipments'),
            value: `${t('contract:vehicleLabels.additionalEquipment.additionalEquipmentLessThanFourThousand')}`,
        },
]);
